// extracted by mini-css-extract-plugin
export var card = "_up-0";